var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    attrs: {
      dense: "",
      items: _vm.listeSites,
      "item-text": "LIC_URL",
      "item-value": "LIC_ID",
      label: _vm._f("cap")(
        _vm.$t("select") + " " + _vm.$tc("sites", 1, { count: "" })
      ),
      "return-object": "",
      "prepend-icon": "language",
      "persistent-hint": _vm.hint.trim().length > 0,
      hint: _vm.hint,
      disabled: _vm.disabled || !_vm.listeSites.length
    },
    on: {
      input: function($event) {
        return _vm.updateSite()
      }
    },
    model: {
      value: _vm.siteTemp,
      callback: function($$v) {
        _vm.siteTemp = $$v
      },
      expression: "siteTemp"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65a6b88a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a6b88a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectOneSiteBot.vue
// module id = null
// module chunks = 